import { Dialog, DialogContent, DialogContentText } from '@mui/material';
import { PaperProps2 } from 'constants';
import { getYesNo } from 'utils/commonUtils';

const ConfirmationDialog = (props) => {
  const {
    openConfirmationDialog,
    setOpenConfirmationDialog,
    title,
    onSubmit,
    handleSubmit,
    loadingButton
  } = props;

  const handleClose = () => {
    setOpenConfirmationDialog(false);
  };
  
  return (
    <>
      <Dialog open={openConfirmationDialog} PaperProps={PaperProps2}>
        <DialogContent>
          <DialogContentText>
            {title}
          </DialogContentText>
        </DialogContent>
        {getYesNo(handleClose, handleSubmit(onSubmit), loadingButton)}
      </Dialog>
    </>
  );
};

export default ConfirmationDialog;
